import React from 'react';
import { X } from 'react-feather';
import PropTypes from 'prop-types';

import Confetti from 'components/ui/Confetti';
import { Icon } from 'ui';
import { pluralize } from 'utils/string_utils';

export default function CertificationConfettiPopover({
  completedCount,
  closePopover,
}) {
  return (
    <div className="LearnCertificationConfettiPopover d-f fd-c jc-c ai-c">
      <div className="LearnCertificationConfettiPopover-arrow" />
      <div className="bg-white bs-3 d-f fd-c p-12 ff-ss mw-100 pos-r">
        <Confetti />
        <button
          type="button"
          className="LearnCertificationConfettiPopover-close u-resetBtn pos-a"
          onClick={closePopover}
        >
          <X size="17" />
        </button>
        <div className="d-f">
          <div className="pos-r mr-12 LearnCertificationConfettiPopover-dust-container">
            <Icon
              className="LearnCertificationConfettiPopover-dust LearnCertificationConfettiPopover-dust--star pos-a"
              name="star-sparkle"
            />
            <Icon
              className="LearnCertificationConfettiPopover-dust LearnCertificationConfettiPopover-dust--dust1 pos-a"
              name="dust1"
            />
            <Icon
              className="LearnCertificationConfettiPopover-dust LearnCertificationConfettiPopover-dust--circle pos-a"
              name="circle-sparkle"
            />
          </div>
          <div className="fz-lg fw-b lh-20">
            {t('certifications.learn.confetti_tooltip.title')}
          </div>
        </div>
        <div className="mt-12 fz-bigger lh-24 wb-bw wr-bw mw-100">
          {pluralize(
            completedCount,
            t('certifications.learn.confetti_tooltip.subtitle_single', {
              completedCount,
            }),
            t('certifications.learn.confetti_tooltip.subtitle_plural', {
              completedCount,
            }),
          )}
        </div>
      </div>
    </div>
  );
}

CertificationConfettiPopover.propTypes = {
  completedCount: PropTypes.number,
  closePopover: PropTypes.func,
};
